var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_4965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 28.9583L30.25 24.7917C29.125 24.2083 27.7083 24.5 26.9167 25.5L23.9583 29.2917C21.0833 27.75 18.875 26.25 16.3333 23.7083C13.625 21 12.1667 18.75 10.6667 15.9583L14.4167 13.0417C15.4167 12.25 15.75 10.8333 15.125 9.70833L10.9583 1.66666C10.2083 0.249998 8.41667 -0.208335 7.125 0.666665L2 4.08333C0.791669 4.875 0.125002 6.25 0.208336 7.66666C0.291669 9.125 0.500002 10.9583 0.833336 12.25C2.33334 18 5.91667 23.9583 10.9583 29C16 34.0417 21.9583 37.625 27.7083 39.125C29 39.4583 30.8333 39.625 32.3333 39.75C33.7917 39.8333 35.1667 39.125 35.9583 37.9167L39.2917 32.7083C40.2083 31.4167 39.7083 29.6667 38.3333 28.9583Z",
    fill: "#C40000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2917 5.125C23.7917 6.08333 26.9583 7.91667 29.5417 10.5C32.125 13.0833 33.9583 16.25 34.9167 19.75C35.0833 20.375 35.6667 20.7917 36.2917 20.7917C36.4167 20.7917 36.5417 20.7917 36.6667 20.75C37.4167 20.5417 37.875 19.75 37.6667 19C36.5833 15.0417 34.5 11.4167 31.5833 8.5C28.6667 5.58333 25.0417 3.45833 21.0833 2.41666C20.3333 2.20833 19.5417 2.66666 19.3333 3.41666C19.0833 4.16666 19.5417 4.91666 20.2917 5.125Z",
    fill: "#C40000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5833 9.16666C21.875 8.83332 21.0417 9.12499 20.7083 9.83332C20.375 10.5417 20.6667 11.375 21.375 11.7083C22.875 12.4167 24.25 13.4167 25.4167 14.5833C26.625 15.7917 27.5833 17.125 28.2917 18.625C28.5417 19.125 29.0417 19.4167 29.5833 19.4167C29.7917 19.4167 30 19.375 30.2083 19.2917C30.9167 18.9583 31.2083 18.125 30.875 17.4167C30 15.625 28.8333 14 27.4167 12.5833C26 11.2083 24.375 10.0417 22.5833 9.16666Z",
    fill: "#C40000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_4965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.7fd94f7530c5f4a8dc1aac564ccd2b57.svg";
export { ForwardRef as ReactComponent };